/* unplugin-vue-components disabled */import { render } from "./1.vue?vue&type=template&id=c5c86c2c&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"

import "../../assets/scss/new3D_detail.scss?vue&type=style&index=0&id=c5c86c2c&scoped=true&lang=scss&external"
import "./1.vue?vue&type=style&index=1&id=c5c86c2c&lang=css"
import "./1.vue?vue&type=style&index=2&id=c5c86c2c&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5c86c2c"]])

export default __exports__